module.exports = __webpack_public_path__ + "static/img/003.7535d52c.svg";